import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=4f5b6300&scoped=true&"
import script from "./UpdateEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=4f5b6300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b6300",
  null
  
)

export default component.exports